import React from 'react'

export default function Graduation({ w, h }) {
    return (
        <svg className='opacity-30   animate-graduation' 
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      enableBackground="new 0 0 512 512"
      viewBox="0 0 58 58"
    >
      <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            fill="#f8e8ab"
            d="M58 41c0 5.52-.9 10-2 10a154.326 154.326 0 00-20.28-1.88l-2.48-1.18A5.984 5.984 0 0032 40.53c-.03-3.32 1.52-6.16.89-7.57 7.74-.096 15.464-.751 23.11-1.96 1.1 0 2 4.48 2 10z"
            data-original="#f8e8ab"
          ></path>
          <path
            fill="#393f4b"
            d="M15 17.06L.67 11.94a1 1 0 010-1.88l27.98-10c.226-.08.474-.08.7 0l27.98 10a1 1 0 010 1.88l-6.4 2.29-2.77.99L43 17.06z"
            data-original="#393f4b"
          ></path>
          <g fill="#f8e8ab" >
            <path 
              d="M2.14 50.97L2 51c.048 0 .096-.01.14-.03zM2.12 31.02A1.131 1.131 0 012 31a.5.5 0 01.12.02zM2.13 31.02a159.013 159.013 0 0021.75 1.91C24.54 34.39 27 37.46 27 41c0 .24 0 .47-.01.7a6 6 0 00-.22 6.24l-2.47 1.12c-7.422.13-14.826.768-22.16 1.91z"
              data-original="#f8e8ab"
            ></path>
          </g>
          <path 
            fill="#ba3a23"
            d="M24.99 41.7c.01-.23.01-.46.01-.7a22.961 22.961 0 00-1.12-8.07c1.64.05 3.35.07 5.12.07 1.33 0 2.63-.01 3.89-.04a21.931 21.931 0 011.1 7.57zM30 51l-2.66 6.37a1 1 0 01-1.85.03l-.73-1.68-1.68.72a.993.993 0 01-1.32-1.28l2.54-6.1.47-1.12zM35.23 47.94l.49 1.18 2.52 6.04a.993.993 0 01-1.32 1.28l-1.68-.72-.73 1.68a1 1 0 01-1.85-.03L30 51z"
            data-original="#ba3a23"
          ></path>
          <path
            fill="#464f5e"
            d="M15 24V13c0-1.66 6.27-3 14-3s14 1.34 14 3v11z"
            data-original="#464f5e"
          ></path>
          <path
            fill="#edc100"
            d="M50 15a1 1 0 01-1-1V7.44a1 1 0 012 0V14a1 1 0 01-1 1z"
            data-original="#edc100"
          ></path>
          <path
            fill="#f1d24b"
            d="M48 16v3a1 1 0 001 1h2a1 1 0 001-1v-3a2 2 0 10-4 0z"
            data-original="#f1d24b"
          ></path>
          <ellipse
            cx="29"
            cy="24"
            fill="#393f4b"
            data-original="#393f4b"
            rx="14"
            ry="3"
          ></ellipse>
          <path
            fill="#e2be50"
            d="M4 41c0 5.28-.82 9.61-1.86 9.97A.319.319 0 012 51c-1.1 0-2-4.48-2-10s.9-10 2-10a.037.037 0 01.03.01c.02 0 .05.01.09.01h.01C3.17 31.37 4 35.7 4 41z"
            data-original="#e2be50"
          ></path>
          <path
            fill="#e04c34"
            d="M36 45a6 6 0 11-6-6 5.878 5.878 0 013.99 1.53A5.961 5.961 0 0136 45z"
            data-original="#e04c34"
          ></path>
        </g>
      </g>
    </svg>
    )
}
